import request from '@/utils/request'

export function getAgentList(params) {
  return request({
    url: '/api/associate/agent/index',
    method: 'get',
    params
  })
}

